module.exports = __webpack_public_path__ + "static/img/70.468b41de.png";